import { NgModule } from '@angular/core';

import { SharedModule }           from '../shared/shared.module';
import { TranslateConfigService } from './translate-config.service';

@NgModule({
  imports: [
    SharedModule
  ],
  providers: [
    TranslateConfigService
  ]
})
export class InternationalizationModule {
  constructor (
    private translateConfigService: TranslateConfigService
  ) {

    this.translateConfigService.init();

    };

  }
